import { MobXProviderContext, observer } from 'mobx-react';
import { ContactModelV2 } from 'Models/ContactModelV2';
import React, { useCallback, useContext } from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { Button } from '~/lib/ui/button';
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuItem,
} from '~/lib/ui/sidebar';
import { GroupMemberCard } from './GroupMemberCard';
import { useGroupMemberContacts } from './hooks/useGroupMemberContacts';
import { GroupDetailsMembersProps } from './index.types';

export const GroupDetailsMembers = observer(
  ({ conversation, openContactDetails }: GroupDetailsMembersProps) => {
    const {
      conversation: { setChannelInfoDetails },
      ui: { setGroupModal, setMoreActionOptions, setOpeningGroupModalFrom },
    } = useContext<RootStoreProps>(MobXProviderContext);

    const { contacts, loadingContacts } = useGroupMemberContacts(
      conversation.id
    );

    const isChannel = conversation.grouping === 'Channel';

    const handleAddMember = useCallback(() => {
      setGroupModal(true);
      setChannelInfoDetails(conversation.id, 'edit');
      setMoreActionOptions({ show: false, conversationId: '' });
      setOpeningGroupModalFrom('edit');
    }, [
      conversation.id,
      setChannelInfoDetails,
      setGroupModal,
      setMoreActionOptions,
      setOpeningGroupModalFrom,
    ]);

    if (loadingContacts) {
      return null;
    }

    return (
      <SidebarGroup className="px-[7px]">
        <SidebarGroupLabel className="flex justify-between">
          Members (
          {
            contacts.filter(
              (contact) =>
                !(contact instanceof ContactModelV2 && contact.deleted)
            ).length
          }
          )
          {isChannel && (
            <Button
              onClick={handleAddMember}
              variant="link"
              size="sm"
              className="p-0 h-auto hover:no-underline"
            >
              Add
            </Button>
          )}
        </SidebarGroupLabel>
        <SidebarMenu className="px-0">
          <SidebarMenuItem className="flex flex-col gap-2 px-0">
            {contacts.map((contact) => (
              <GroupMemberCard
                key={contact.id}
                contact={contact}
                openContactDetails={openContactDetails}
              />
            ))}
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroup>
    );
  }
);
